import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../helpers/custom-prop-types';
const FacebookIcon = ({ className }) => (_jsx("svg", Object.assign({ className: `svg-facebook-icon ${className}`, height: '19.878', viewBox: '0 0 20 19.878', width: '20', xmlns: 'http://www.w3.org/2000/svg' }, { children: _jsx("path", { d: 'M-483,75a10,10,0,0,0-10-10,10,10,0,0,0-10,10,10,10,0,0,0,8.438,9.878V77.891H-497.1V75h2.539V72.8a3.529,3.529,0,0,1,3.777-3.891,15.378,15.378,0,0,1,2.239.2v2.461h-1.261a1.445,1.445,0,0,0-1.63,1.562V75h2.773l-.443,2.891h-2.33v6.988A10,10,0,0,0-483,75Z', fill: '#1877f2', transform: 'translate(503 -65)' }) })));
FacebookIcon.propTypes = {
    className: propStr(),
};
FacebookIcon.defaultProps = {
    className: '',
};
export default FacebookIcon;
